<template>
  <div id="app">
    <app-header></app-header>
    <router-view></router-view>
    <tryout-modal></tryout-modal>
  </div>
</template>

<script>
import AppHeader from 'components/app-header/app-header';
import TryoutModal from 'pages/index/tryout';

export default {
  components: {
    AppHeader,
    TryoutModal,
  },
};
</script>

<style lang="scss">
  #app {
    .bounce-enter-active {
      animation: bounce-in 0.3s;
    }

    .bounce-leave-active {
      animation: bounce-in 0.3s reverse;
    }

    @keyframes bounce-in {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.02);
      }
      100% {
        transform: scale(1);
      }
    }
  }
</style>
